/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Entity
 * @desc Filter to toggle between deleted items
 */

import { FilterPostReportEntityForm } from 'labstep-web/components/FilterPost/NewIndex/Entity/Form';
import type { FilterPostNewIndexEntityProps } from 'labstep-web/components/FilterPost/NewIndex/Entity/types';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';

export const FilterPostNewIndexEntity: React.FC<
  FilterPostNewIndexEntityProps
> = ({
  label,
  path,
  field,
  addPostFilter,
  defaultValues,
  entityName,
  extraParams,
  ...rest
}) => (
  <Modal
    header={`Filter by ${label}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
        dataCy={`components/FilterPost/NewIndex/Entity:${entityName}`}
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportEntityForm
        addPostFilter={addPostFilter}
        path={path}
        field={field}
        defaultValues={defaultValues}
        onDone={toggleModal}
        entityName={entityName}
        extraParams={extraParams}
      />
    )}
    {...rest}
  />
);
